import { toast } from '@sales-center/components'

import { post, isAPIError } from '@user/store/services/crud'

import { topStatsUrl } from '../constants'
import { ActivitySummaryHelpers } from '../helpers'
import type { ActivitySummaryFilterSet } from '../typings'
import { setActivitySummaryStatsActionCreator as setData } from '../state'

export async function fetchTopStats(
  filters: ActivitySummaryFilterSet['filters'],
) {
  const params = ActivitySummaryHelpers.filterToTopStats(filters)

  const response = await post(`${topStatsUrl}`, params)

  if (!response.ok) {
    const result = await response.json()

    if (isAPIError(result)) {
      toast.error(result.Message)
    } else {
      toast.error('Failed to fetch Activity Summary')
    }

    return setData({
      toDoPercentage: 0,
      toDoTotalCount: 0,
      completeTotalCount: 0,
      deferredPercentage: 0,
      deferredTotalCount: 0,
      avgTimeToCompletion: 0,
      inProgressPercentage: 0,
      inProgressTotalCount: 0,
    })
  }

  return setData(await response.json())
}
